module.exports = __webpack_public_path__ + "img/mobile-button.bb52b5de.svg";